"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Button_1 = __importStar(require("@app/routes/SpeechDevelopment/components/Button"));
const useWindowWidrh_1 = __importDefault(require("@hooks/useWindowWidrh"));
const BoxComponentWithImg_1 = __importDefault(require("@app/routes/SpeechDevelopment/components/BoxComponentWithImg"));
const useCoins_1 = __importDefault(require("@hooks/useCoins"));
const audioPlayer_1 = require("@app/services/audioPlayer");
const uiConfigs_1 = require("@app/constants/uiConfigs");
const helpers_1 = require("@app/helpers");
const loading_1 = __importDefault(require("@components/loading"));
const quantityGame_1 = __importDefault(require("@components/quantity/quantityGame"));
const menuBarExercise_1 = __importDefault(require("@components/menuBar/menuBarExercise"));
const exercise_1 = require("@components/container/exercise");
const Pagination_1 = require("@components/Pagination");
const sendInfoReport_1 = require("@app/utils/sendInfoReport");
const useBeforeUnloadReport_1 = require("@hooks/useBeforeUnloadReport");
const translations_1 = require("@app/routes/SpeechDevelopment/translations");
const components_1 = require("@app/routes/SpeechDevelopment/components");
let infoRep = [];
let currentAnswer = '';
let index = 0;
let checkedAnswer = [];
/**
 *
 * @component
 * @param {SynonymProps} props - The props for the FakeDisinhibition component.
 * @param {Record<string, any> | null} props.response - The response object containing exercise data.
 * @param {string | null} [props.description] - The description of the exercise.
 * @param {number} [props.langId] - The language ID for speech recognition (e.g., 1 for Russian, 2 for English).
 * @returns {JSX.Element} The rendered FakeDisinhibition component.
 *
 * @example
 * ```tsx
 * <FakeDisinhibition
 *   response={{
 *     text: {
 *       title: "Disinhibition ExerciseParams",
 *       offers: [
 *         { id: "1", right_word: "happy", additional_correct_words: ["joyful"], audio: "..." }
 *       ]
 *     },
 *     id: "123"
 *   }}
 *   description="Say the correct word or phrase."
 *   langId={1}
 * />
 * ```
 */
const FakeDisinhibition = ({ response, description, langId }) => {
    const [data, setData] = (0, react_1.useState)([]);
    const [, setInitialData] = (0, react_1.useState)([]);
    const [recognizer, setRecognizer] = (0, react_1.useState)(null);
    const [isRecognizing, setIsRecognizing] = (0, react_1.useState)(false);
    const [currentCardIndex, setCurrentCardIndex] = (0, react_1.useState)(0);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const { coinCount, rubyCount, diamondCount, addCoin } = (0, useCoins_1.default)();
    const windowWidth = (0, useWindowWidrh_1.default)();
    (0, useBeforeUnloadReport_1.useBeforeUnloadReport)(() => ({ infoRep, exerciseId: (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), checkedAnswer }));
    const [checkButtons, setCheckButtons] = (0, react_1.useState)((0, helpers_1.generateInitialState)(10));
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (response) {
            setData((_b = (_a = response === null || response === void 0 ? void 0 : response.text) === null || _a === void 0 ? void 0 : _a.offers) === null || _b === void 0 ? void 0 : _b.sort((a, b) => a.order - b.order));
            setInitialData((_d = (_c = response === null || response === void 0 ? void 0 : response.text) === null || _c === void 0 ? void 0 : _c.offers) === null || _d === void 0 ? void 0 : _d.sort((a, b) => a.order - b.order));
            setCheckButtons((0, helpers_1.generateInitialState)((_f = (_e = response === null || response === void 0 ? void 0 : response.text) === null || _e === void 0 ? void 0 : _e.offers) === null || _f === void 0 ? void 0 : _f.length));
            checkedAnswer = (0, helpers_1.generateInitialState)((_h = (_g = response === null || response === void 0 ? void 0 : response.text) === null || _g === void 0 ? void 0 : _g.offers) === null || _h === void 0 ? void 0 : _h.length);
        }
    }, [response]);
    (0, react_1.useEffect)(() => {
        setIsLoading(true);
        const initRecogniser = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            const stream = yield window.navigator.mediaDevices.getUserMedia({ audio: true });
            // @ts-ignore
            const newOptions = [...new Set(((_b = (_a = data === null || data === void 0 ? void 0 : data.flatMap(item => {
                    var _a, _b;
                    const words = ['start', 'stop', 'fake', 'word'];
                    if ((_a = item.additional_words) === null || _a === void 0 ? void 0 : _a.length)
                        words.push(...item.additional_words);
                    if ((_b = item.additional_correct_words) === null || _b === void 0 ? void 0 : _b.length)
                        words.push(...item.additional_correct_words);
                    if (item.right_word)
                        words.push(item.right_word);
                    return words;
                })) === null || _a === void 0 ? void 0 : _a.map(word => word.toLowerCase())) !== null && _b !== void 0 ? _b : []))];
            // @ts-ignore
            const recognizerInstance = new window.RecognizerSpeechDev(newOptions);
            yield recognizerInstance.init(stream, langId);
            setRecognizer(recognizerInstance);
            setIsLoading(false);
        });
        if (data === null || data === void 0 ? void 0 : data.length) {
            initRecogniser();
        }
    }, [response, data]);
    (0, react_1.useEffect)(() => {
        return () => {
            if (recognizer) {
                recognizer.stop();
            }
            document.removeEventListener('recognizeWordEvent', handleRecognizeWordEvent);
        };
    }, [recognizer]);
    const startRecognition = () => __awaiter(void 0, void 0, void 0, function* () {
        const currentCard = data[currentCardIndex];
        try {
            setIsRecognizing(true);
            infoRep = [...infoRep, {
                    rep_id: currentCard === null || currentCard === void 0 ? void 0 : currentCard.id,
                    category_name: '',
                    system_time: '',
                    startTime: Date.now()
                }];
            if (currentCard === null || currentCard === void 0 ? void 0 : currentCard.full_question_audio) {
                audioPlayer_1.audioPlayer.stopAudio();
                yield audioPlayer_1.audioPlayer.playAudio(null, currentCard === null || currentCard === void 0 ? void 0 : currentCard.full_question_audio);
            }
            else if (currentCard === null || currentCard === void 0 ? void 0 : currentCard.audio) {
                audioPlayer_1.audioPlayer.stopAudio();
                yield audioPlayer_1.audioPlayer.playAudio('x', currentCard === null || currentCard === void 0 ? void 0 : currentCard.audio);
            }
            document.addEventListener('recognizeWordEvent', handleRecognizeWordEvent);
        }
        catch (error) {
            console.error('Error accessing microphone:', error);
        }
    });
    const stopRecognition = () => {
        if (recognizer) {
            recognizer.stop();
            setIsRecognizing(false);
            index = 0;
            setCurrentCardIndex(0);
            setCheckButtons(uiConfigs_1.initialButtonState);
            checkedAnswer = uiConfigs_1.initialButtonState;
        }
    };
    const handleRecognizeWordEvent = (e) => {
        var _a, _b;
        const word = ((_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.word) || '';
        const currentItem = data === null || data === void 0 ? void 0 : data[currentCardIndex || index];
        const correctWords = ((_b = currentItem === null || currentItem === void 0 ? void 0 : currentItem.additional_correct_words) === null || _b === void 0 ? void 0 : _b.length)
            ? currentItem.additional_correct_words
            : [currentItem === null || currentItem === void 0 ? void 0 : currentItem.right_word];
        let isCorrect = false;
        if (typeof word === 'string' && word.includes(' ')) {
            // Split the word into an array if it contains spaces and has length > 1
            const wordArray = word.toLowerCase().split(' ').filter(w => w.trim() !== '');
            if (wordArray.length > 1) {
                isCorrect = wordArray.some(w => correctWords.map(cw => cw === null || cw === void 0 ? void 0 : cw.toLowerCase()).includes(w));
            }
            else {
                // Single word case
                isCorrect = correctWords
                    .map(w => w === null || w === void 0 ? void 0 : w.toLowerCase())
                    .includes(word === null || word === void 0 ? void 0 : word.toLowerCase());
            }
        }
        else {
            // Single word case
            isCorrect = correctWords
                .map(w => w === null || w === void 0 ? void 0 : w.toLowerCase())
                .includes(word === null || word === void 0 ? void 0 : word.toLowerCase());
        }
        if (isCorrect) {
            currentAnswer = word;
        }
        const updatedData = data === null || data === void 0 ? void 0 : data.map((item, idx) => {
            if ((isCorrect) && ((index || currentCardIndex) === idx)) {
                return (Object.assign(Object.assign({}, item), { isCorrect: true }));
            }
            return item;
        });
        setData(updatedData);
        setCheckButtons((prevButtons) => {
            const indexToUpdate = prevButtons.findIndex((button, idx) => !button.isChecked && idx === index);
            if (indexToUpdate === -1) {
                checkedAnswer = prevButtons;
                return prevButtons;
            }
            const updatedButtons = prevButtons.map((button, idx) => {
                if (idx === indexToUpdate) {
                    return Object.assign(Object.assign({}, button), { isChecked: true, isCorrect: isCorrect });
                }
                return button;
            });
            checkedAnswer = updatedButtons;
            return updatedButtons;
        });
        handleAnswer(isCorrect);
    };
    const handleAnswer = (isCorrect) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g;
        const nextIndex = index + 1;
        const isLast = nextIndex >= (data === null || data === void 0 ? void 0 : data.length);
        // Always track time for current rep before doing anything else
        infoRep = (0, sendInfoReport_1.trackAttemptTime)(infoRep, isCorrect);
        console.log('[ExerciseReport] FakeDisinhibition rep ended, correct=' + isCorrect + ', infoRep:', JSON.stringify(infoRep));
        if (isCorrect) {
            yield addCoin(3, 5);
            if (!isLast) {
                infoRep = [...infoRep, {
                        rep_id: (_a = data[nextIndex]) === null || _a === void 0 ? void 0 : _a.id,
                        category_name: '',
                        system_time: '',
                        startTime: Date.now()
                    }];
                setCurrentCardIndex(nextIndex);
                index = nextIndex;
                currentAnswer = '';
                yield audioPlayer_1.audioPlayer.playAudio(`audio_${index}`, ((_b = data[nextIndex]) === null || _b === void 0 ? void 0 : _b.full_question_audio) || ((_c = data[nextIndex]) === null || _c === void 0 ? void 0 : _c.audio));
            }
            else {
                // @ts-ignore
                window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
                console.log('[ExerciseReport] FakeDisinhibition sending report, infoRep:', JSON.stringify(infoRep));
                // @ts-ignore
                (0, sendInfoReport_1.sendInfoReport)(infoRep, (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), window.userId, checkedAnswer);
            }
        }
        else {
            audioPlayer_1.audioPlayer.stopAudio();
            yield audioPlayer_1.audioPlayer.playAudio((0, audioPlayer_1.getPreloadSoundKey)(langId, 315));
            yield audioPlayer_1.audioPlayer.playAudio('c', (_d = data[index || currentCardIndex]) === null || _d === void 0 ? void 0 : _d.right_audio);
            setCheckButtons(updadteButtons);
            if (!isLast) {
                infoRep = [...infoRep, {
                        rep_id: (_e = data[nextIndex]) === null || _e === void 0 ? void 0 : _e.id,
                        category_name: '',
                        system_time: '',
                        startTime: Date.now()
                    }];
                index = nextIndex;
                setCurrentCardIndex(nextIndex);
                yield audioPlayer_1.audioPlayer.playAudio('v', ((_f = data[nextIndex]) === null || _f === void 0 ? void 0 : _f.full_question_audio) || ((_g = data[nextIndex]) === null || _g === void 0 ? void 0 : _g.audio));
            }
            else {
                // @ts-ignore
                window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
                console.log('[ExerciseReport] FakeDisinhibition sending report, infoRep:', JSON.stringify(infoRep));
                // @ts-ignore
                (0, sendInfoReport_1.sendInfoReport)(infoRep, (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), window.userId, checkedAnswer);
            }
        }
    });
    const handleButtonClick = () => {
        if (!isLoading) {
            if (isRecognizing) {
                stopRecognition();
                // @ts-ignore
                window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
                // @ts-ignore
                (0, sendInfoReport_1.sendInfoReport)(infoRep, (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), window.userId, checkedAnswer);
            }
            else {
                startRecognition();
            }
        }
    };
    const updadteButtons = (prevButtons) => {
        const indexToUpdate = prevButtons
            .findIndex((button, idx) => !button.isChecked && idx === index);
        if (indexToUpdate === -1) {
            checkedAnswer = prevButtons;
            return prevButtons;
        }
        const updatedButtons = prevButtons.map((button, idx) => {
            if (idx === indexToUpdate) {
                return Object.assign(Object.assign({}, button), { isChecked: true, isCorrect: false });
            }
            return button;
        });
        checkedAnswer = updatedButtons;
        return updatedButtons;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exercise_1.ContainerExercise, null,
            react_1.default.createElement(exercise_1.ExerciseWrapper, { wihMargin: windowWidth <= 1200 },
                isLoading && !isRecognizing ?
                    react_1.default.createElement(loading_1.default, { setIsLoading: setIsLoading, text: description, langId: langId }) : null,
                react_1.default.createElement(components_1.DropContainerWrapper, null,
                    react_1.default.createElement(BoxComponentWithImg_1.default, { customAnswer: currentAnswer, isDisinhibition: true, list: [data[currentCardIndex]] }),
                    react_1.default.createElement(quantityGame_1.default, { diamondCount: diamondCount, rubyCount: rubyCount, goldCoin: coinCount })),
                react_1.default.createElement(Pagination_1.Pagination, null, checkButtons.map((item, index) => react_1.default.createElement(Pagination_1.PaginationItem, { key: index, item: item, active: item.isCorrect && item.isChecked ?
                        "linear-gradient(130deg, #6cff4f 13.21%, #13c21c 81.73%)" :
                        !item.isCorrect && item.isChecked ? "#FF1431" : null })))),
            react_1.default.createElement(menuBarExercise_1.default, null,
                react_1.default.createElement(Button_1.ButtonContainerWrapper, null,
                    react_1.default.createElement(Button_1.default, { isShowShadow: true, isStarted: isRecognizing, label: (0, translations_1.getLabelPauseButton)(langId, isRecognizing), isCheckButton: false, onClick: handleButtonClick }))))));
};
exports.default = FakeDisinhibition;
